import { render, staticRenderFns } from "./NewsListFilterPanel.vue?vue&type=template&id=4196f8ac&scoped=true"
import script from "./NewsListFilterPanel.vue?vue&type=script&lang=js"
export * from "./NewsListFilterPanel.vue?vue&type=script&lang=js"
import style0 from "./NewsListFilterPanel.vue?vue&type=style&index=0&id=4196f8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4196f8ac",
  null
  
)

export default component.exports